
(function () {
  'use strict';

  var landing = document.querySelector('.rs-landing');
  if (!landing) return;

  // === Attiva la modalità landing sul <body> ===
  // Nasconde in modo affidabile header/footer/announcement del TEMA
  // (vedi CSS body.rs-landing-active ...), senza dipendere dalla classe
  // template-rs-landing che Shopify non sempre espone sul <body>.
  document.body.classList.add('rs-landing-active');

  // === NAV scroll background ===
  var nav = document.getElementById('rs-nav');
  if (nav) {
    var onScroll = function () {
      if (window.scrollY > 30) nav.classList.add('scrolled');
      else nav.classList.remove('scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // === Reveal on scroll ===
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.rs-reveal').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.rs-reveal').forEach(function (el) {
      el.classList.add('in');
    });
  }

  // === Reviews carousel — dot nav update ===
  var track = document.getElementById('rs-reviewsTrack');
  if (track) {
    var dots = document.querySelectorAll('.rs-reviews-dot');
    track.addEventListener('scroll', function () {
      var firstCard = track.querySelector('.rs-review-card');
      if (!firstCard) return;
      var cardWidth = firstCard.offsetWidth + 16;
      var idx = Math.round(track.scrollLeft / cardWidth);
      dots.forEach(function (d, i) {
        d.classList.toggle('active', i === idx);
      });
    }, { passive: true });
  }

  // === Reviews "Leggi tutto" ===
  document.querySelectorAll('.rs-review-card .rs-read-more').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var card = btn.closest('.rs-review-card');
      card.classList.toggle('expanded');
      btn.textContent = card.classList.contains('expanded')
        ? 'Riduci ↑'
        : 'Leggi tutto →';
    });
  });

  // === Mobile burger — toggle classe (drawer gestito da CSS) ===
  var burger = document.querySelector('.rs-burger');
  var navList = document.querySelector('.rs-nav-list');
  if (burger && navList) {
    burger.addEventListener('click', function () {
      var isOpen = navList.classList.toggle('rs-mobile-open');
      burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  // === Mega menu mobile — accordion on click ===
  var hasMega = document.querySelectorAll('.rs-has-mega');
  hasMega.forEach(function (li) {
    var link = li.querySelector('a');
    if (!link) return;
    link.addEventListener('click', function (e) {
      if (window.innerWidth > 1024) return;
      e.preventDefault();
      li.classList.toggle('rs-mega-open');
    });
  });

  // === Chiudi drawer cliccando link interno (non "Esperienze ▾") ===
  document.querySelectorAll('.rs-nav-list a').forEach(function (link) {
    var isInMegaParent = link.closest('.rs-has-mega') && !link.closest('.rs-mega');
    if (isInMegaParent) return;
    link.addEventListener('click', function () {
      if (window.innerWidth > 1024) return;
      if (navList && navList.classList.contains('rs-mobile-open')) {
        navList.classList.remove('rs-mobile-open');
        if (burger) burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      }
    });
  });

  // === Reset stato al resize ===
  window.addEventListener('resize', function () {
    if (window.innerWidth > 1024 && navList && navList.classList.contains('rs-mobile-open')) {
      navList.classList.remove('rs-mobile-open');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  });
})();